import { useTestTemplateStore } from './stores/testTemplate'
import { useViewStateStore } from './stores/viewState'
import { viewTypes } from '@features/ViewState/types/viewTypes'

let lastReloadDebugPayload = null

/** Last [reload-debug] console payload — attached to Chrome-iOS Sentry noise for context. */
export const getLastReloadDebugPayload = () => lastReloadDebugPayload

const snapshot = () => {
    try {
        const template = useTestTemplateStore()
        const view = useViewStateStore()
        const question = template.currentTestQuestion || {}
        const questions = template.currentTestQuestions
        return {
            view: view.currentView,
            isRealTest: view.isRealTest,
            mainIndex: template.currentTestMainCategoryIndex,
            subIndex: template.currentTestSubCategoryIndex,
            questionIndex: template.currentTestQuestionIndex,
            questionCount: Array.isArray(questions) ? questions.length : 0,
            treeCount: Array.isArray(template.allTestQuestions) ? template.allTestQuestions.length : 0,
            questionId: question.id ?? null,
            questionType: question.aufgaben_typ ?? null,
            isFirst: template.isFirstQuestionOverall,
            isLast: template.isLastQuestion,
            isQuestionPresenter: view.currentView === viewTypes.questionPresenter,
        }
    } catch (e) {
        return { snapshotFailed: String(e && e.message ? e.message : e) }
    }
}

export const reloadDebug = (step, extra = {}) => {
    const payload = { step, at: Date.now(), ...snapshot(), ...extra }
    lastReloadDebugPayload = payload
    console.warn('[reload-debug]', payload)
}
